import React, { Component } from 'react';

import { SketchPicker } from 'react-color';

import Modal from 'react-modal';
import GradientBuilder from '../GradientBuilder';

Modal.setAppElement('#root');

const WrappedSketchPicker = ({ onSelect, ...rest }) => (
  <SketchPicker {...rest} onChange={c => onSelect(c.hex)} />
);

class ModalStylesGradient extends Component {
  render() {
    const {
      isOpen,
      handleClose,
      onPaletteChange,
      handleAccept,
      palette,
    } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        className="modal-gradient"
        overlayClassName="modal-gradient__ovarlay">
        <p>ModalStylesGradient</p>
        <GradientBuilder
          palette={palette ? palette : undefined}
          {...{
            width: 280,
            height: 32,
            pallette: palette,
            onPaletteChange: palette => onPaletteChange({ palette }),
          }}>
          <WrappedSketchPicker
            {...{
              width: 240,
              disableAlpha: true,
            }}
          />
        </GradientBuilder>
        <div className="modal-gradient__bottom">
          <button
            className="btn btn-blue outline small m-r-15"
            onClick={handleClose}>
            close
          </button>
          <button className="btn btn-blue small" onClick={handleAccept}>
            submit
          </button>
        </div>
      </Modal>
    );
  }
}

export default ModalStylesGradient;



// WEBPACK FOOTER //
// ./src/components/ModalStylesGradient/ModalStylesGradient.js